/**
 * Shared social-provider metadata for the login/signup UI, plus a server
 * function that reports which providers are actually configured.
 *
 * `getEnabledSocialProviders` reads the list computed in `auth.ts` (a provider
 * is enabled only when both its client id and secret are set) so the auth
 * pages render a "Continue with …" button only for providers that will work —
 * no dead buttons in a dev environment with no OAuth credentials. The
 * `@/lib/server/auth` import is referenced only inside the handler, so the
 * TanStack Start compiler strips it (and the server-only auth module) from the
 * client bundle.
 */
import { createServerFn } from '@tanstack/react-start'

export type SocialProvider = 'google' | 'github' | 'microsoft'

export const SOCIAL_PROVIDER_LABELS: Record<SocialProvider, string> = {
  google: 'Google',
  github: 'GitHub',
  microsoft: 'Microsoft',
}

export const getEnabledSocialProviders = createServerFn({
  method: 'GET',
}).handler(async (): Promise<SocialProvider[]> => {
  const { enabledSocialProviders } = await import('@/lib/server/auth')
  return enabledSocialProviders
})
